import { getEmbedUrl } from "@/lib/video";

const SmartVideo = ({ url, poster, autoPlay = true, testId, className = "w-full aspect-video bg-night" }) => {
  const embed = getEmbedUrl(url, autoPlay);
  if (embed) {
    return (
      <iframe
        data-testid={testId}
        src={embed}
        className={className}
        allow="autoplay; fullscreen; picture-in-picture"
        allowFullScreen
        title="Video"
      />
    );
  }
  return (
    <video
      data-testid={testId}
      src={url}
      poster={poster}
      className={className}
      controls
      autoPlay={autoPlay}
      playsInline
      preload={autoPlay ? "auto" : "none"}
    />
  );
};

export default SmartVideo;
